module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bird@2x_e4be7b.png";